module.exports = __webpack_public_path__ + "static/Tuomas Auvinen-50ba5988733db1c2c013d025b19c5456.jpeg";